<div class=" grid grid-cols-1 "
    *ngIf="genAiRequest">
    <div class="md:col-span-3 bg-white p-0 rounded shadow-xl "
         style="">
        <h3 class="text-2xl font-extrabold text-left mt-5 mb-0">
            <img src="assets/img/lua-magician.svg" 
                alt="Main Image" 
                class="w-10 "
                width="40px" 
                style="display:inline" />

            Generative Iteration
            <!-- Itera&ccedil;&atilde;o  -->
            <!--
            Relat&oacute;rios
            Regenerativos
            -->

            
        </h3>
        <span class="opacity-70 text-xs ml-14">
            Est&aacute; a falar com
            {{ assistantName }}
        </span>

        <hr/>

        <div class="grid grid-cols-1 mt-1 mb-2">
            <div class="grid-col">
                <div style="min-height:150px;background-color:#f4f4f4"
                    class="pt-3 pb-5 pl-5">
                    <h2 class="font-bold text-xs bottom-4  rounded">
                        <!--
                        <span class="text-black">Doc {{ doc.realname }}</span> &nbsp;
                        <span class="text-black opacity-70">criado em {{ doc.tms }} por {{ doc.created_by }}.</span>
                        <span style="font-size:x-small" class="opacity-70">
                            id: {{ doc.fileid }}
                        </span>
                        <span style="font-size:x-small" class="opacity-70">
                            filename: {{ doc.filename }}
                        </span>
                        <button class="border p-3 rounded-full bg-[#5BACAD] text-white border-[#5BACAD] flex items-center"
                            (click)="startGenAi()">
                            Iniciar !!!
                        </button>
                        -->
                    </h2>

                    <!-- <h3>ACTUAL SCREEN</h3> -->
                    <div class="grid grid-cols-1">
                        <div class="grid-col">
                            <div style="max-height: 400px;overflow: hidden;overflow-y: scroll;">    
                                <div class="mt-3" *ngIf="bufMessages.length===0">
                                    <p class="mt-1 mb-1"
                                        (click)="beginConversation()">
                                        <span class="cursor-pointer text-[small] p-2 bg-[#fff] rounded-xl font-bold text-[#00527E] m-2"
                                              style="border: 1px solid rgb(0, 82, 126);"> 
                                            COME&Ccedil;AR A CONVERSA
                                        </span>
                                    </p>
                                </div>

                                <app-msgbuf 
                                    [content]="bufMessages"
                                    [onResendQ]="resendQuestion">
                                </app-msgbuf>
                            </div>
                        </div>

                        <div class="grid-col">
                            <div class="input-container w-full  ">
                                <div *ngIf="is_loading" class="flex items-center rounded-xl rounded-tl-none p-[1rem] w-[7rem] ">
                                    <app-rounded-icon-buttom [buttonData]="{iconUrl:'assets/img/quadro.svg',btnClass:'w-[3rem] h-[3rem] '}" />
                                    <div role="status">
                                        <svg aria-hidden="true" class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor" />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill" />
                                        </svg>
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>

                                <div class="flex justify-center items-center">
                                    <input type="text" 
                                        placeholder="Enviar mensagem ao assistente"
                                        class="bg-white border-solid border border-[#BBCAD2] rounded-full text-black !w-4/5 h-[3.254rem] ps-10 pe-16 focus:outline-none duration-150  "
                                         (input)="onInputChange($event)" 
                                         [value]="inputValue"
                                         (keydown)="handelKeyDown($event)" 
                                    />
                                    <div class="input-icon">
                                        <input type="file" class="hidden" #file (change)="uploadFile($event)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
